// ** Initial State
const initialState = {
  data: {},
  params: {},
  dashloading: false,
  customerOnline: [],
  overAllGraph: [],
  overAllSummarize: null,
  healthDepositWithdraw: null,
  healthPaymentGateway: null,
  customerBalance: null
}

const dashboardData = (state = initialState, action) => {
  switch (action.type) {
    case 'DASHBOARD_GET_DATA':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    case 'clear_dashboard_data':
      return {
        ...state,
        data: {},
        params: {},
        dashloading: false,
        customerOnline: [],
        overAllGraph: [],
        overAllSummarize: null
      }
    case 'DASH_LOADING':
      return {
        ...state,
        dashloading: action.dashloading
      }
    case 'DASHBOARD_CUSTOMER_ONLINE':
      return {
        ...state,
        customerOnline: action.data
      }
    case 'DASHBOARD_CUSTOMER_BALANCE':
      return {
        ...state,
        customerBalance: action.data
      }
    case 'DASHBOARD_OVERALL_GRAPH':
      return {
        ...state,
        overAllGraph: action.data
      }
    case 'DASHBOARD_CUSTOMER_SUMMARIZE':
      return {
        ...state,
        overAllSummarize: action.data
      }
    case 'DASHBOARD_HEALTH_PAYMENTGATEWAY':
      return {
        ...state,
        healthPaymentGateway: action.data
      }
    case 'DASHBOARD_HEALTH_DEPOSIT_WITHDRAW':
      return {
        ...state,
        healthDepositWithdraw: action.data
      }
    default:
      return { ...state }
  }
}

export { dashboardData }